<ng-template cdkPortal #actions="cdkPortal">
  <a class="btn btn-icon btn-secondary"
     [routerLink]="createPath"
     [queryParams]="query.filters">
    <icon-plus></icon-plus>
    <span class="ml-2">Add product</span>
  </a>
</ng-template>


<smart-table [headers]="headers"
             [source]="source"
             [collapseAuto]="false"
             (filtersChange)="onSearch($event)"
             (sortChange)="onSort($event)"
             [collapseByClick]="true"
             (collapsedChange)="initForm($event)">
  <ng-template smartTableColumn="id" let-item>
    <td>
      <entity-link type="product"
                   [item]="item"
                   [strong]="true"
                   [relativePath]="relativePath"
                   [isEntity]="isEntity">
      </entity-link>
      <div>
        <div class="d-inline-block"
             [popper]="popperDevice"
             popperApplyClass="popper-primary, popper-lg">
          <ng-container [ngTemplateOutlet]="deviceCode" [ngTemplateOutletContext]="{$implicit: false}"></ng-container>
        </div>
      </div>

      <popper-content #popperDevice>
        <ng-container [ngTemplateOutlet]="deviceCode" [ngTemplateOutletContext]="{$implicit: true}"></ng-container>
      </popper-content>
    </td>

    <ng-template #deviceCode let-popper>
      <div class="d-flex align-items-center">
        <icon-apple [style.width.px]="10" class="mr-2 text-muted"></icon-apple>
        <span [class.pseudo-link]="!popper">
              {{ item.appleProductId | reducer: popper ? item.appleProductId.length : 20 }}
            </span>
      </div>

      <div class="d-flex align-items-center" [class.mt-n2]="!popper">
        <icon-android [style.width.px]="10" class="mr-2 text-muted"></icon-android>
        <span [class.pseudo-link]="!popper">
              {{ item.googleProductId | reducer: popper ? item.googleProductId.length : 20 }}
            </span>
      </div>
    </ng-template>
  </ng-template>

  <ng-template smartTableColumn="type" let-item>
    <td>
      {{ item.type  | upperFirst }}
    </td>
  </ng-template>

  <ng-template smartTableColumn="store" let-item>
    <td>
      <entity-link type="store" [item]="item.parentStore" [relativePath]="relativePath"></entity-link>
    </td>
  </ng-template>

  <ng-template smartTableColumn="subject" let-item>
    <td>
      <ng-container *ngIf="item.type === ProductType.NonConsumable && item.project">
        Project:<br> {{ item.project.name }} <br>
        <small class="text-muted">ID {{ item.project.id }}</small>
      </ng-container>
      <ng-container *ngIf="item.type === ProductType.NonConsumable && item.storeCollection">
        Collection:<br> {{ item.storeCollection.name }} <br>
        <small class="text-muted">ID {{ item.storeCollection.id }}</small>
      </ng-container>
      <ng-container *ngIf="item.type === ProductType.Subscription">
        Period:<br> {{ item.subscriptionPeriod }} <br>
      </ng-container>
      <ng-container *ngIf="item.type === ProductType.Consumable">
        Coins: {{ item.coinsValue }}
      </ng-container>
    </td>
  </ng-template>

  <ng-template smartTableColumn="innerProduct" let-item>
    <td>
      <badge-exist existText="Inner product" existColor="success" [item]="item.innerProduct"></badge-exist>
    </td>
  </ng-template>


  <ng-template smartTableColumn="createdAt" let-item>
    <td>
      {{ item.createdAt | moment }}
    </td>
  </ng-template>


<!--  <ng-template smartTableColumn="actions" let-item>-->
<!--    <td class="text-right text-nowrap">-->
<!--      <button class="btn btn-danger btn-square btn-icon" (click)="delete(item.id, 'product', item.name)">-->
<!--        <icon-trash></icon-trash>-->
<!--      </button>-->
<!--    </td>-->
<!--  </ng-template>-->
  <ng-template smartTableCollapse let-item let-index="index" let-collapse="collapse">
    <form [formGroup]="forms[item.id]" (ngSubmit)="save(item, index)">
      <div class="row">
        <div class="col-60">
          <div class="form-group">
            <label>Name</label>
            <form-group-simple name="name" placeholder="Name" formControlName="name"></form-group-simple>
          </div>
        </div>
        <div class="col-30">
          <div class="form-group">
            <label>Google product ID</label>
            <form-group-simple name="googleProductId" placeholder="Google product id" formControlName="googleProductId"></form-group-simple>
          </div>
        </div>
        <div class="col-30">
          <div class="form-group">
            <label>Apple product ID</label>
            <form-group-simple name="appleProductId" placeholder="Apple product id" formControlName="appleProductId"></form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-30">
          <div class="form-group">
            <label>Type</label>
            <form-group-select [searchable]="true"
                               [items]="types"
                               placeholder="Type"
                               formControlName="type">
            </form-group-select>
          </div>
        </div>
        <div class="col-30" *ngIf="forms[item.id].get('coinsValue')">
          <div class="form-group">
            <label>Amount</label>
            <form-group-simple name="coinsValue" inputType="number" placeholder="amount" formControlName="coinsValue"></form-group-simple>
          </div>
        </div>
        <div class="col-30" *ngIf="forms[item.id].get('subscriptionPeriod')">
          <div class="form-group">
            <label>Subscription period</label>
            <form-group-simple name="subscriptionPeriod" inputType="number" placeholder="0" formControlName="subscriptionPeriod"></form-group-simple>
          </div>
        </div>
        <div class="col-30" *ngIf="forms[item.id].get('entity')">
          <div class="form-group">
            <label>Entity</label>
            <form-group-select bindLabel="label"
                               bindValue="key"
                               [searchable]="true"
                               [items]="entities"
                               placeholder="Entity"
                               formControlName="entity">
            </form-group-select>
          </div>
        </div>
        <div class="col-30" *ngIf="forms[item.id].get('project') && forms[item.id].get('entity').value === 'project'">
          <div class="form-group">
            <label>Project</label>
            <form-group-select entity="project"
                               bindLabel="name"
                               [searchable]="true"
                               placeholder="Project"
                               formControlName="project"
                               (ngModelChange)="forms[item.id].get('storeCollection').setValue(null)">
            </form-group-select>
          </div>
        </div>
        <div class="col-30" *ngIf="forms[item.id].get('storeCollection') && forms[item.id].get('entity').value === 'storeCollection'">
          <div class="form-group">
            <label>Collection</label>
            <form-group-select entity="storeCollection"
                               bindLabel="name"
                               [searchable]="true"
                               placeholder="Collection"
                               formControlName="storeCollection"
                               (ngModelChange)="forms[item.id].get('project').setValue(null)">
            </form-group-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-auto">
          <div class="form-group">
            <form-group-simple type="checkbox" name="innerProduct" formControlName="innerProduct">Inner product</form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-30" *ngIf="forms[item.id].get('coinsCost')">
          <div class="form-group">
            <label>Coins cost</label>
            <form-group-simple name="coinsCost" inputType="number" placeholder="Coins cost" formControlName="coinsCost"></form-group-simple>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-auto">
<!--          <btn-delete form actions type="product"-->
<!--                      [name]="item.name"-->
<!--                      (delete)="delete($event, item.id)">-->
<!--          </btn-delete>-->
        </div>
        <div class="col-auto ml-auto">
          <div class="m-n2">
            <button class="btn btn-success m-2" type="submit" [disabled]="forms[item.id].disabled">
              Save
            </button>
            <button class="btn btn-outline-info m-2" type="button"
                    (click)="cancel(collapse)">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
  </ng-template>
</smart-table>

<pagination [itemsOnPage]="pagination.limit"
            [page]="pagination.currentPage"
            (pageChanged)="setPage($event)"
            [itemsFull]="pagination.fullCount"></pagination>

<preloader [hidden]="!loaderService.isLoading"></preloader>


